export default __webpack_public_path__ + "static/media/retangles-login.18ef027c.svg";